export const getRandomDate = (daysBack: number = 30): string => {
    const today = new Date();
    const startDate = new Date();
    startDate.setDate(today.getDate() - daysBack);

    const randomTime = startDate.getTime() +
        Math.random() * (today.getTime() - startDate.getTime());

    return new Date(randomTime).toISOString();
};

export const getRelativeDate = (days: number): string => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString();
};

export const formatWithCurrentTime = (dateStr: string): string => {
    const date = new Date(dateStr);
    const now = new Date();
    date.setFullYear(now.getFullYear());
    date.setMonth(now.getMonth());
    date.setDate(now.getDate());
    return date.toISOString();
};
